var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUkr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 256V512H16H32V448V384H175.756H319.512L351.5 416L383.488 448H447.744C483.085 448 512.013 447.663 512.03 447.25C512.046 446.837 490.559 360.438 464.282 255.25L416.505 64H352.99H289.475L273.5 32L257.525 0H128.762H0V256Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289 64.503C289 64.78 303.15 93.304 320.445 127.891C337.74 162.478 351.615 191.051 351.279 191.388C350.942 191.725 271.767 192 175.333 192H0V352V512H16H32V448V384H175.756H319.512L351.5 416L383.488 448H447.744C483.085 448 512.013 447.663 512.03 447.25C512.046 446.837 490.559 360.438 464.282 255.25L416.505 64H352.753C317.689 64 289 64.226 289 64.503Z",
    fill: "#407DC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289 64.503C289 64.78 303.15 93.304 320.445 127.891C337.74 162.478 351.615 191.051 351.279 191.388C350.942 191.725 271.767 192 175.333 192H0V352V512H16H32V448V384H175.756H319.512L351.5 416L383.488 448H447.744C483.085 448 512.013 447.663 512.03 447.25C512.046 446.837 490.559 360.438 464.282 255.25L416.505 64H352.753C317.689 64 289 64.226 289 64.503Z",
    fill: "#005AF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 352V512H16H32V448V384H175.756H319.512L351.5 416L383.488 448H447.744C483.085 448 512.013 447.663 512.029 447.25C512.045 446.837 501.359 403.638 488.284 351.25L464.511 256H424.258H384.006L368 224L351.994 192H175.997H0V352Z",
    fill: "#616161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 288V384H223.744H447.488L415.5 416L383.512 448H447.756C483.09 448 512.013 447.663 512.029 447.25C512.045 446.837 501.359 403.638 488.284 351.25L464.511 256H424.258H384.006L368 224L351.994 192H175.997H0V288Z",
    fill: "#00FFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 288V384H223.744H447.488L415.5 416L383.512 448H447.756C483.09 448 512.013 447.663 512.029 447.25C512.045 446.837 501.359 403.638 488.284 351.25L464.511 256H424.258H384.006L368 224L351.994 192H175.997H0V288Z",
    fill: "#BFC370"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 288.004V384.009L223.994 383.754L447.989 383.5L415.75 415.75L383.512 448H447.756C483.09 448 512.013 447.663 512.029 447.25C512.045 446.837 501.359 403.638 488.284 351.25L464.511 256H423.993H383.475L367.5 224L351.525 192H175.762H0V288.004Z",
    fill: "#FFE646"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.494 416.25L383.5 448.5L415.75 416.506C445.722 386.772 448.45 384 447.744 384C447.603 384 433.091 398.512 415.494 416.25Z",
    fill: "#806C18"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkr);
export default __webpack_public_path__ + "static/media/ukr.46bd73abb37db3d42416fac10048b94a.svg";
export { ForwardRef as ReactComponent };